import {createFileRoute} from "@tanstack/react-router";
import {z as zod} from "zod";
import {robustJsonResultClientFetch} from "@vesta/error-handling-remix/fetches/robustJsonResultClientFetch";
import {uniqueUuid} from "@vesta/unique/unique";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {adminUserDetailValidator, type AdminUserDetail} from "~/domainModels/adminModels/adminUserDetails";

export const USER_DETAILS_QUERY_KEY = uniqueUuid`e6f4a5b7-0c1d-4e2f-c4d5-b6c7d8e9f0a1`;

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/user-profiles")({
    loader: async ({context}) => {
        const platformUser = await context.queryClient.ensureQueryData<Array<AdminUserDetail>>({
            queryKey: [USER_DETAILS_QUERY_KEY],
            queryFn: async () => {
                const result = await robustJsonResultClientFetch(
                    `${context.intellsysBaseUrl}/sub-system/pluto/admin/user-details/get`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${context.authenticationStatus.accessToken}`,
                        },
                        body: JSON.stringify({}),
                    },
                    zod.array(adminUserDetailValidator),
                );
                if (result.success !== true) {
                    throw new Error("Failed to fetch user details");
                }
                return result.data;
            },
        });

        return {
            platformUser,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
